// extracted by mini-css-extract-plugin
export default {"departments":"tF-z","departmentHeading":"uF-z","departmentSection":"vF-z","departmentName":"wF-z","departmentLink":"xF-z","expandIcon":"yF-z"};